import { TResourceTypeChange } from '@/data/types';
import { createAction } from '@reduxjs/toolkit';

export const storeSocketId = createAction<string | undefined>('sockets/storeSocketId');

export const initSocket = createAction('sockets/initSocket');

export const setConnectionStatus = createAction<boolean>('sockets/setConnectionStatus');

export const healthCheck = createAction<{ organizationId: string | undefined }>('sockets/healthCheck');

export const setDataReloadResource = createAction<TResourceTypeChange[] | null>('sockets/setDataReloadResource');
